import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	DeviceLicense,
	DeviceLicenseState,
	DeviceLicenseWarningDetails
} from '@shure/shared/angular/data-access/system-api/models';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

import { LicenseStateTitlePipe } from '../../../pipes';
import { LicenseStateDescriptionPipe } from '../../../pipes/license-state-description.pipe';

@Component({
	selector: 'sh-device-license-warning',
	standalone: true,
	imports: [CommonModule, TranslocoModule, LicenseStateTitlePipe, LicenseStateDescriptionPipe],
	providers: [provideInlineScope('scDeviceLicense', (lang) => import(`../../../../i18n/${lang}`))],
	templateUrl: './device-license-warning.component.html',
	styleUrls: ['./device-license-warning.component.scss']
})
export class DeviceLicenseWarningComponent {
	@Input() public warningTemplateRef!: TemplateRef<{ message: string }>;
	@Input() public errorTemplateRef!: TemplateRef<{ message: string }>;

	@Input() public deviceLicense!: DeviceLicense<DeviceLicenseWarningDetails>;

	protected readonly deviceLicenseStateEnum = DeviceLicenseState;
}
